module.exports = "/images/mountain_left_2x.png";